import { render } from "./MessagesInbox.vue?vue&type=template&id=0392d4b0&scoped=true"
import script from "./MessagesInbox.vue?vue&type=script&lang=js"
export * from "./MessagesInbox.vue?vue&type=script&lang=js"

import "./MessagesInbox.vue?vue&type=style&index=0&id=0392d4b0&lang=css"
import "./MessagesInbox.vue?vue&type=style&index=1&id=0392d4b0&lang=css"
import "./MessagesInbox.vue?vue&type=style&index=2&id=0392d4b0&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/FLOCKR/FLOCKER-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0392d4b0"]])

export default __exports__